import {
  BambooHRLogo,
  BitvavoLogo,
  CanonLogo,
  DoodleLogo,
  FrontifyLogo,
  KarbonLogo,
  LogitechLogo,
  LushLogo,
  NedapLogo,
  OmnisendLogo,
  UScreenLogo,
  VirginMediaLogo,
  VismaLogo,
} from './SVGCustomerLogos'

export const sliteWebsiteCustomerList = [
  { name: 'Doodle', logo: DoodleLogo, migratedFrom: 'Notion' },
  { name: 'Lush', logo: LushLogo, migratedFrom: 'Confluence' },
  { name: 'Frontify', logo: FrontifyLogo, migratedFrom: 'ClickUp' },
  { name: 'Karbon', logo: KarbonLogo, migratedFrom: 'Quip' },
  { name: 'Visma', logo: VismaLogo, migratedFrom: 'OneNote' },
  { name: 'Omnisend', logo: OmnisendLogo, migratedFrom: 'Confluence' },
]

export const defaultSliteCustomerList = [
  { name: 'Bitvavo', logo: BitvavoLogo },
  { name: 'Lush', logo: LushLogo },
  { name: 'Doodle', logo: DoodleLogo },
  { name: 'Canon', logo: CanonLogo },
  { name: 'Logitech', logo: LogitechLogo },
  { name: 'Virgin Media', logo: VirginMediaLogo },
  { name: 'Visma', logo: VismaLogo },
  { name: 'BambooHR', logo: BambooHRLogo },
  { name: 'Karbon', logo: KarbonLogo },
  { name: 'Nedap', logo: NedapLogo },
  { name: 'Frontify', logo: FrontifyLogo },
  { name: 'Uscreen', logo: UScreenLogo },
]
